import { updateSaasMootaSetups } from '@lib/axios/moota'
import { useMutation, useQueryClient } from 'react-query'
import useSuccess from '@hooks/useSuccess'
import useCloseDialog from '@hooks/useCloseDialog'

const useUpdate = () => {
  const showSuccess = useSuccess('Sukses', 'Sukses Mengubah Moota')
  const closeDialog = useCloseDialog()
  const queryClient = useQueryClient()
  const mutation = useMutation(
    (mdata) => updateSaasMootaSetups(
      mdata.id,
      mdata.name,
      mdata.bank_name,
      mdata.account_number,
      mdata.personal_token
    ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('saas-moota')
      },
    }
  )

  return (data) => mutation.mutate(data, {
    onError: () => closeDialog(),
    onSuccess: () => {
      showSuccess()
    },
  })
}

export default useUpdate
